// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/recent-history/recent-history.less
// module id = 3647
// module chunks = 0